import React, { useContext } from 'react'
import { DownloadPileMutation, MutationExportPilesArgs, PileNode } from '@src/generated/schema'
import { Button, List } from 'antd'
import { Pile } from '@src/graphql/Pile'
import { TOAST_TYPES, ToastContext } from '@src/components/Providers'
import { useTranslation } from 'react-i18next'
import { APIError } from '@src/components/Elements/Wrapper/Form'

import { useMutation } from '@apollo/client/react'

export interface IExportPiles {
  closeModal: () => void

  piles: Array<Pick<PileNode, 'id' | 'number'>>
}

const ListFooter = ({
  error,
  loading,
  onClick,
}: {
  error: Error | undefined
  loading: boolean
  onClick: () => Promise<void>
}) => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column-reverse' }}>
      {error && <APIError error={error} />}
      <Button loading={loading} type='primary' disabled={loading} onClick={onClick}>
        {t('desktop.pages.piles.exportPiles.title')}
      </Button>
    </div>
  )
}

export const ExportPiles: React.FC<IExportPiles> = ({ piles, closeModal }) => {
  const { setToast } = useContext(ToastContext)
  const { t } = useTranslation()
  const [exportPilesFun, { error, loading }] = useMutation<
    { exportPiles?: DownloadPileMutation | null },
    MutationExportPilesArgs
  >(Pile.exportPiles)

  const dataSource = piles.map((x) => ({ title: x.number }))
  const pilesIds = piles.map((x) => x.id)

  const handleDownloadPiles = async () => {
    setToast({
      type: TOAST_TYPES.INFO,
      message: 'Info',
      description: t('general.pile.import.toast.info.takestime'),
    })
    const result = await exportPilesFun({ variables: { pilesIds } })
    const url = result.data?.exportPiles?.url
    if (!url) {
      return
    }
    setToast({
      type: TOAST_TYPES.SUCCESS,
      message: t('desktop.pages.piles.exportPiles.toast.message'),
      description: t('desktop.pages.piles.exportPiles.toast.description'),
    })
    closeModal()
    window.location.assign(url)
  }

  return (
    <List
      itemLayout={'horizontal'}
      dataSource={dataSource}
      renderItem={(item) => <List.Item>{item.title}</List.Item>}
      header={pilesIds.length > 0 && <ListFooter loading={loading} error={error} onClick={handleDownloadPiles} />}
    />
  )
}
